import React from 'react';

const MeetingSortContext = React.createContext();

export default MeetingSortContext;
